import React, { Component } from 'react';
import { assetImg } from "@/modules/moduleImporter";
import { IGameResultHistoryProps } from "@/types/GameHistoryTypes";

import "./index.scss";
 
export default class M17 extends Component<IGameResultHistoryProps> {
	render() {
		const alternatingStyle = "sl-roadmap-alternating";
		const reversedHistory = this.props.history.slice(0).reverse();
		// const historyBlink = this.props.historyBlink;
			
		// return (
		// 	<div className="history-container m7">
		// 	{
		// 		reversedHistory.slice(0, 6).map((data, idx) =>
		// 			<div key={`grh_m7_${idx}`} className={historyBlink && idx === 0 ? alternatingStyle : ""}>
		// 			{
		// 				data.angka.split(",").map((item, _idx) => 
		// 					<div key={"m7_" + item + _idx}>
		// 						{ assetImg("m7", item + "") }
		// 					</div>
		// 				)
		// 			}
		// 			</div>
		// 		)
		// 	}
		// 	</div>
		// );

		return (
			<div className="history-container m17">
			{
				reversedHistory.slice(0, 2).map((data, idx) =>
					<div className="item-container m17" key={`grh_m17_${idx}`}>
					{
						data.angka.split("").map((item, _idx) => 
							<div className="m17 item-history" key={"m17_" + item + _idx}>
								<div className={`ball-tm c-${item}`}><span>{item}</span></div>
							</div>
						)
					}
					</div>
				)
			}
			</div>
		);
	}
}
